import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Input from './components/Input';
import Button from './components/Button'
import fetchWP from './utils/fetchWP';
import Toggle from 'react-toggle';
import Modal from 'react-modal';
import ReactResponsiveSelect from 'react-responsive-select';
import moment from 'moment';

// import styled from "styled-components";

//Custom Components 
import FormGroup from './components/FormGroup'
//End Custom Components 

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//Custom Components 
import Scheduler from './components/Scheduler'
import QuantityRange from './components/QuantityRange'

const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px"
        viewBox="351.584 2118.292 11.848 6.338">
        <g>
            <path
                d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z" />
        </g>
    </svg>
);

const multiSelectOptionMarkup = (text) => (
    <div>
        <span className="checkbox">
            <svg className="checkbox-icon" x="0px" y="0px" width="12px" height="12px" viewBox="0 0 488.878 488.878">
                <g><polygon
                    points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298 " /></g>
            </svg>
        </span>
        <span> {text}</span>
    </div>
);

const parseValue = (value, date, time, zone) => {
    const parsed = moment(value).parseZone();
    const returnObject = {
        dateValue: parsed.isValid() ? parsed.format('YYYY-MM-DD') : date,
        timeValue: parsed.isValid() ? parsed.format('HH:mm') : time,
        zoneValue: '+0800',
    };
    return returnObject;
};

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const productList = window.awdp_object.productlist;

const productLists = [{ text: 'All', value: 0 }]; 

if (productList) {
    for (var i = 0; i < productList.length; i++) {
        productLists.push({ text: productList[i]['name'], value: productList[i]['id'] })
    }
}

function isEligible(value) {
    if (value !== false || value !== null || value !== 0 || value !== "") {
        return value;
    }
}

// let newDate = new Date();

const emptyRule = {
    id: false,
    name: '',
    label: 'Discount',
    active: false,
    inc_tax: false,
    sequentially: true,
    // apply_once: false,
    priority: 1,
    discount_type: '',
    discount: '',
    coupon: '',
    rules: [],
    schedules: [{ "start_date": new Date(), "end_date": '' }],
    quantityranges: [{ start_range: '', end_range: '', dis_type: '', dis_value: '' }],
    product_list: '',
    startTime: '',
    endTime: '',
};
export default class Details extends Component {
    onChange = (model) => {
        this.setState({
            model
        });
    }

    /* This lifecycle hook gets executed when the component mounts */
    handleChangenew = (e) => {
        this.setState((prevState) => ({
            rule: { ...prevState.rule, enddate: e }
        }))
    }

    handleNameChange = (evt) => {
        this.setState({ name: evt.target.value });
    }

    handleShareholderNameChange = (idx) => (evt) => {
        const newShareholders = this.state.shareholders.map((shareholder, sidx) => {
            if (idx !== sidx) return shareholder;
            return { ...shareholder, name: evt.target.value };
        });

        this.setState({ shareholders: newShareholders });
    }

    handleAddShareholder = () => {
        this.setState({ shareholders: this.state.shareholders.concat([{ name: '' }]) });
    }

    handleRemoveShareholder = (idx) => () => {
        this.setState({ shareholders: this.state.shareholders.filter((s, sidx) => idx !== sidx) });
    }

    constructor(props) {
        super(props);
        this.state = {
            action: this.props.match.params.id == 'add' ? 'add' : 'update',
            redirect: false,
            modalIsOpen: false,
            isHidden: true,
            errorClass: false,
            discountoptions: '',
            bogocategories: false,
            name: '',
            awdpLoader: true,
            shareholders: [{ name: '' }],
            rule: emptyRule
        }

        this.fetchWP = new fetchWP({
            restURL: window.awdp_object.root,
            restNonce: window.awdp_object.api_nonce,
        });

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);
        this.handleBogoChange = this.handleBogoChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleFormDeletion = this.handleFormDeletion.bind(this);

        //Model
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
        this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
        this.handleScheduleChange = this.handleScheduleChange.bind(this);

        updateDisabled: false;
        deleteDisabled: false;
        actionDisabled: false;
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    handleRuleChange(data) {
        this.setState((prevState) => ({
            rule: { ...prevState.rule, rules: data }
        }))
    }

    handleScheduleChange(data) {
        this.setState((prevState) => ({
            rule: { ...prevState.rule, schedules: data }
        }))
    }

    handleQRangeChange(data) {
        this.setState((prevState) => ({
            rule: { ...prevState.rule, quantityranges: data }
        }))
    }

    handleEndTimeChange(time) {
        (time > this.state.rule.startTime) ?
            this.setState((prevState) => ({
                rule: { ...prevState.rule, endTime: time }, errorClass: false
            }))
            : this.setState({ errorClass: true });
    }

    handleStartTimeChange(time) {
        this.setState((prevState) => ({
            rule: { ...prevState.rule, startTime: time }, errorClass: false
        }))
    }

    handleProductChange(data) {
        let options = data.options.map(e => {
            return e.value;
        });
        // this.setState((prevState) => ({
        //     data: update(this.state.products, {  products: { rule: { value: { $set: options } } } })
        // }), () => {
        //     this.props.onChange(this.state.products)
        // })
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id != prevProps.match.params.id) {
            if (this.props.match.params.id == 'add') {
                this.setState(prevState => ({
                    rule: { ...prevState.rule, ...emptyRule }
                }));
            } else {
                this.fetchRule();
            }
        }
    }

    fetchRule() {
        this.setState({
            awdpLoader: true
        });
        this.fetchWP.get('rules/' + this.props.match.params.id)
            .then(
                (json) => {
                    // var start_date = json.start_date + ' ' + json.start_time;
                    // var end_date = json.end_date + ' ' + json.end_time;
                    // console.log(json.product_list);
                    this.setState(prevState => (
                        {
                            rule: {
                                ...prevState.rule,
                                name: json.name,
                                label: json.label,
                                id: json.id,
                                priority: json.priority,
                                discount: json.discount,
                                discount_type: json.discount_type,
                                // usage_limit: json.usage_limit,
                                product_list: json.product_list,
                                schedules: json.schedules,
                                quantityranges: json.quantityranges,
                                quantity_type: json.quantity_type,
                                table_layout: json.table_layout,
                                // start_date: start_date,
                                // end_date: end_date,
                                sequentially: json.sequentially == 1 ? true : false,
                                // apply_once:  json.sequentially == 1 ? true : false,
                                inc_tax: json.inc_tax == 1 ? true : false,
                                show_in_loop: json.show_in_loop == 1 ? true : false,
                                disable_on_sale: json.disable_on_sale == 1 ? true : false,
                                status: json.status == 1 ? true : false,
                                pricing_table: json.pricing_table == 1 ? true : false,
                                rules: json.rules != '' ? json.rules : [],
                                startTime: moment(json.start_time + 'Z'),
                                endTime: moment(json.end_time + 'Z'),
                                // discount_schedule_weekday: json.schedule_weekday,
                                // discount_schedule_days: json.discount_schedule_days != '' ? json.discount_schedule_days : ['null']
                            },
                            awdpLoader: false
                        }
                    ));
                }
            );
    }

    componentDidMount() {
        let title = 'Edit rule';
        if (this.props.match.params.id == 'add') {
            title = 'Add New';
            this.setState({
                awdpLoader: false
            });
        } else {
            this.fetchRule();
        }
        document.body.classList.add('wdpa-details'); 
    }

    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleSelect(e) {
        let value = e.value;
        let name = e.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleDayChange(newValue) {
        if (newValue.altered) {
            let numrows = newValue.options.length;
            let rows = [];
            for (var i = 0; i < numrows; i++) {
                rows.push(newValue.options[i].value);
            }
            this.setState(prevState => ({
                rule: {
                    ...prevState.rule, discount_schedule_days: rows
                }
            }));
        }
    }

    handleModeChange(e) {
        let value = e.value;
        let name = e.name;

        if (value == 'discount_options' || value == 'percentage_price' || value == 'percentage_total_amount' || value == 'fixed_price' || value == 'fixed_total_amount') {
            this.setState({
                discountoptions: 'discount'
            });
        } else if (value == 'bogo') {
            this.setState({
                discountoptions: 'bogo'
            });
        } else if (value == 'bogo_x') {
            this.setState({
                discountoptions: 'bogo_x'
            });
        } else if (value == 'gift' || value == 'bulk') {
            this.setState({
                discountoptions: 'gift'
            });
        }

        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleBogoChange(e) {
        let value = e.value;
        let name = e.name;

        if (value == 'category') {
            this.setState({
                bogocategories: true
            });
        } else {
            this.setState({
                bogocategories: false
            });
        }

        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleStatusChange(e) {
        let value = e.target.checked;
        let name = e.target.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value, active: value
            }
        }))
    }

    handleFormSubmit(e) {
        e.preventDefault();
        if (this.state.action == 'add') {
            this.createRule();
        } else {
            this.updateRule();
        }
    }

    handleFormDeletion(e) {
        e.preventDefault();
        let ruleData = { 'id': this.state.rule.id };
        this.setState({
            actionDisabled: true
        });
        this.fetchWP.post('delete', ruleData)
            .then(
                (json) => {
                    window.location = json;
                    this.setState({
                        actionDisabled: false
                    });
                }
            );
    }

    createRule() {
        let ruleData = this.state.rule;
        ruleData.model = this.state.model;
        this.setState({
            isHidden: false,
            updateDisabled: true,
            deleteDisabled: true
        });
        this.fetchWP.post('rules', ruleData)
            .then(
                (json) => {
                    console.log(json);
                    this.setState(prevState => ({
                        redirect: true,
                        isHidden: true,
                        updateDisabled: false,
                        deleteDisabled: false,
                        rule: { ...prevState.rule, id: json }
                    }))
                    console.log(this.state);
                }
            );
    }

    updateRule() {
        let ruleData = this.state.rule;
        let sparseArray = ruleData.rules.filter(isEligible);
        if (sparseArray.length != 0) {
            for (i = 0; i < sparseArray.length; i++) {
                sparseArray[i].rules = sparseArray[i].rules.filter(isEligible);
            }
        }
        ruleData.rules = sparseArray.filter(isEligible);
        this.setState({
            isHidden: false,
            updateDisabled: true,
            deleteDisabled: true
        });
        this.fetchWP.post('rules', ruleData)
            .then(
                (json) => {
                    console.log(json);
                    this.setState({
                        isHidden: true,
                        updateDisabled: false,
                        deleteDisabled: false
                    });
                }
            );
    }

    render() {
        const buttonStyle = {
            margin: '10px 10px 10px 10px'
        }
        const hideButton = {
            display: 'none'
        }
        const AWRPLoader = () => (
            <div className="awdp_loader"></div>
        );
        const AWRPStatus = () => (
            <div class="awpr_update_text">Saving Changes...</div>
        );
        return (
            <div className="awdp_detail clearfix">
                { this.state.awdpLoader != false ? <div className="awdp_loader"></div> : '' }
                { this.state.redirect ? <Redirect to={'/rule/' + this.state.rule.id} /> : '' }
                <div className="awdp_detail_top">
                    <h4>Allo Good day !!</h4>
                    <p>Setting the discount rate is easy. Just play with the below settings and watch the changes</p>
                </div>
                { !this.state.isHidden && <AWRPStatus /> }
                <Tabs>

                    <TabList>
                        <Tab>Discount Settings</Tab>
                        <Tab>Schedule</Tab>
                        <Tab>Rules and Restrictions</Tab>
                    </TabList>

                    <TabPanel>

                        <div className="awdp_field_group">
                            <Input inputType={'text'}
                                title={'Rule Name'}
                                name={'name'}
                                value={this.state.rule.name}
                                placeholder={'Enter rule name'}
                                handleChange={this.handleInput} />
                            <div className="form-group">
                                <div className="sub-group">
                                    <Input inputType={'number'}
                                        title={'Priority'}
                                        name={'priority'}
                                        min={'1'}
                                        value={this.state.rule.priority}
                                        placeholder={'Enter discount priority'}
                                        handleChange={this.handleInput} />
                                </div>
                                <div className="sub-group">
                                    <label className="form-label">Active</label>
                                    <Toggle
                                        name={'status'}
                                        icons={false}
                                        value={this.state.rule.status}
                                        checked={this.state.rule.status}
                                        onChange={this.handleStatusChange} />
                                </div>
                            </div>

                            <p className="helpText">*Cart based rules will have the least priority and will be applied once the product is added to the cart.</p> 
                            <div className="form-group">
                                <label className="form-label">Product Lists</label>
                                <ReactResponsiveSelect
                                    name={'product_list'}
                                    options={productLists}
                                    caretIcon={caretIcon}
                                    // noSelectionLabel={'Select Product List'}
                                    onChange={this.handleSelect}
                                    selectedValue={this.state.rule.product_list} />
                            </div>

                            <div className="form-group">
                                <label className="form-label">Discount Type</label>
                                <ReactResponsiveSelect
                                    name={'discount_type'}
                                    options={[
                                        { text: 'Product Rules', optHeader: true },
                                        { text: 'Fixed price of product price', value: 'fixed_product_price' },
                                        { text: 'Percentage of product price', value: 'percent_product_price' },
                                        { text: 'Cart Rules', optHeader: true },
                                        { text: 'Fixed price of cart total amount', value: 'fixed_cart_amount' },
                                        { text: 'Percentage of cart total amount', value: 'percent_total_amount' },
                                        { text: 'Quantity Rules', optHeader: true },
                                        { text: 'Quantity based discount', value: 'cart_quantity' }
                                    ]}
                                    onChange={this.handleModeChange}
                                    caretIcon={caretIcon}
                                    selectedValue={this.state.rule.discount_type} />
                            </div>

                            
                            { ( this.state.rule.discount_type == 'fixed_cart_amount' || this.state.rule.discount_type == 'percent_total_amount' || this.state.rule.discount_type == 'cart_quantity') ? 
                                <div>
                                    { this.state.rule.discount_type != 'cart_quantity' ?
                                        <p className="helpText">*Discounts will be applied as Fee with Discount Label</p> 
                                    :
                                        ''
                                    }
                                    <Input inputType={'text'}
                                        title={'Discount Label'}
                                        name={'label'}
                                        value={this.state.rule.label}
                                        placeholder={'Enter Discount Label'}
                                        handleChange={this.handleInput} />
                                </div>
                            : 
                                ''
                            }

                            <div>
                                {this.state.rule.discount_type == 'cart_quantity' ?
                                    <div className="quantity_outter awdp_background">
                                        <div className="form-group quantity_details">
                                            <div className="quantity_wrap">
                                                <div class="awdp_discount_desc qn_desc">
                                                    <h3>Quantity based discount</h3>
                                                    <p>You can set quantity based discounts on cart items / products</p>
                                                </div>
                                                <div className="sub-group">
                                                    <label className="form-label">Type</label>
                                                    <ReactResponsiveSelect
                                                        name={'quantity_type'}
                                                        options={[
                                                            { text: 'Quantity based discount on product prices', value: 'type_product' },
                                                            { text: 'Quantity based discount on cart items', value: 'type_cart' }
                                                        ]}
                                                        onChange={this.handleModeChange}
                                                        caretIcon={caretIcon}
                                                        selectedValue={this.state.rule.quantity_type} />
                                                </div>
                                                {this.state.rule.quantity_type == 'type_product' ?
                                                    <div className="sub-group">
                                                        <div className="sub-group">
                                                            <label className="form-label">Show pricing table</label>
                                                            <Toggle
                                                                name={'pricing_table'}
                                                                icons={false}
                                                                value={this.state.rule.pricing_table}
                                                                checked={this.state.rule.pricing_table}
                                                                onChange={this.handleStatusChange} />
                                                        </div>
                                                        <div className="sub-group">
                                                            <label className="form-label">Table layout</label>
                                                            <ReactResponsiveSelect
                                                                name={'table_layout'}
                                                                options={[
                                                                    { text: 'Vertical', value: 'vertical' },
                                                                    { text: 'Horizontal', value: 'horizontal' }
                                                                ]}
                                                                onChange={this.handleModeChange}
                                                                caretIcon={caretIcon}
                                                                selectedValue={this.state.rule.table_layout} />
                                                        </div>
                                                    </div>
                                                : 
                                                    <div className="sub-group">
                                                        <p className="infoMessage">*Discounts will be applied as Fee with Discount Label</p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <QuantityRange quantityranges={this.state.rule.quantityranges}
                                                onChange={(data) => {
                                                    this.handleQRangeChange(data);
                                                }} />
                                        </div>
                                    </div>
                                :
                                    <div className="form-group">
                                        <div className="sub-group">
                                            <Input inputType={'number'}
                                                title={'Discount Value'}
                                                name={'discount'}
                                                min={'0'}
                                                value={this.state.rule.discount}
                                                placeholder={'Discount percentage / amount'}
                                                handleChange={this.handleInput} />
                                        </div>
                                        <div className="sub-group">
                                            <label className="form-label">Including Tax</label>
                                            <Toggle
                                                name={'inc_tax'}
                                                icons={false}
                                                value={this.state.rule.inc_tax}
                                                checked={this.state.rule.inc_tax}
                                                onChange={this.handleStatusChange} />

                                        </div>
                                    </div>
                                }

                                { ( this.state.rule.discount_type == 'percent_total_amount' || this.state.rule.discount_type == 'percent_product_price' ) ?
                                    <div className="form-group">
                                        <label className="form-label">Apply sequentially (When applying multiple discounts, apply the first discount to the full price and the second discount to the discounted price and so on.) </label>
                                        <Toggle
                                            name={'sequentially'}
                                            icons={false}
                                            value={this.state.rule.sequentially}
                                            checked={this.state.rule.sequentially}
                                            onChange={this.handleStatusChange} />
                                    </div>
                                : 
                                    ''
                                }

                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">Disable discount if product is on sale</label>
                            <Toggle
                                name={'disable_on_sale'}
                                icons={false}
                                value={this.state.rule.disable_on_sale}
                                checked={this.state.rule.disable_on_sale}
                                onChange={this.handleStatusChange} />
                        </div>

                    </TabPanel>

                    <TabPanel>

                        <div className="awdp_field_group">
                            <div className="awdp_discount_desc">
                                <h3>Schedule Discount Sale</h3>
                                <p>You can set schedule discount sales using the provided options</p>
                            </div>
                            <div className="form-group">
                                <Scheduler schedules={this.state.rule.schedules}
                                    onChange={(data) => {
                                        this.handleScheduleChange(data);
                                    }} />
                            </div>
                        </div>

                    </TabPanel>

                    <TabPanel>

                        <div className="awdp_field_group">
                            <div className="awdp_discount_desc">
                                <h3>Apply Rules</h3>
                                <p>You can set discount rule using the provided options</p>
                            </div>
                            <div className="form-group">
                                <FormGroup rules={this.state.rule.rules} type={this.state.rule.discount_type}
                                    onChange={(data) => {
                                        this.handleRuleChange(data);
                                    }} />
                            </div>
                        </div>

                    </TabPanel>

                </Tabs>

                <div className="save_changes">
                    <Button action={
                        this.openModal}
                        type={'secondary'}
                        title={'Delete'}
                        style={this.props.match.params.id == 'add' ? hideButton : buttonStyle}
                        disabled={this.state.deleteDisabled} />
                    <Button action={
                        this.handleFormSubmit}
                        type={'primary'}
                        title={this.props.match.params.id == 'add' ? 'Publish' : 'Update'}
                        style={buttonStyle}
                        disabled={this.state.updateDisabled} />
                    {!this.state.isHidden && <AWRPLoader />}
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        style={customStyles}
                        contentLabel="Delete">
                        <h2 ref={subtitle => this.subtitle = subtitle}>All discount related datas will be removed.</h2>
                        <h4 ref={subtitle => this.subtitle = subtitle}>Are you sure to proceed?</h4>
                        <Button action={
                            this.closeModal}
                            type={'primary'}
                            title={'No'}
                            style={buttonStyle}
                            disabled={this.state.actionDisabled} />
                        <Button action={
                            this.handleFormDeletion}
                            type={'secondary'}
                            title={'Yes'}
                            style={buttonStyle}
                            disabled={this.state.actionDisabled} />
                        {this.state.actionDisabled ? <div className="warning_msg">Deleting.. Please Wait..</div> : ''}
                    </Modal>
                </div>
            </div>
        )
    }
}